import { defineMessages, useIntl } from 'react-intl';
import type { FieldValues } from 'react-hook-form';
import type { FieldConfig } from '../../../../components/field';
import type { FieldHookArgs } from '../../../../components/forms/model/types';

const messages = defineMessages({
    email: {
        id: 'account.forgot-password.email',
        defaultMessage: 'Email Address',
    },
    fieldRequiredMessage: {
        id: 'account.forgot-password.error.required',
        defaultMessage: '{field} field is required',
    },
    fieldInvalidMessage: {
        id: 'account.forgot-password.error.invalid',
        defaultMessage: 'Please enter a valid {field}',
    },
});
export function useForgotPasswordFields<T extends FieldValues = FieldValues>({
    form: {
        control,
        formState: { errors },
    },
}: FieldHookArgs<T>): Record<string, FieldConfig> {
    const intl = useIntl();

    const fields: Record<string, FieldConfig> = {
        email: {
            id: 'account-forgot-password-email-input',
            name: 'email',
            type: 'email',
            label: intl.formatMessage(messages.email),
            defaultValue: '',
            rules: {
                required: intl.formatMessage(messages.fieldRequiredMessage, { field: 'Email' }),
                pattern: {
                    value: /\S+@\S+\.[\S]{2,6}/,
                    message: intl.formatMessage(messages.fieldInvalidMessage, {
                        field: 'email address',
                    }),
                },
            },
            error: errors.email,
            control,
            variant: 'new-style',
        },
    };

    return fields;
}
